import { DRYBULK_CARGO_OPS_BFF_SERVICE_SEGMENT } from "@config/apiConfig";
import { useNotification } from "@context/NotificationContext";
import {
  printFinalDelayReport,
  printFinalLoadingReport,
} from "@services/drybulkCargoOperationsApi";
import { runTransaction } from "@telemetry/runTransaction";
import { printRequestedTemplate } from "@utils/printRequestedTemplate";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_TELEMETRY } from "../constants";

export type PrintReportKind = "loading" | "delay";

const TELEMETRY = {
  loading: {
    action: "print_final_loading_report",
    screen: DRYBULK_CARGO_OPS_TELEMETRY.finalLoadingReportScreen,
  },
  delay: {
    action: "print_final_delay_report",
    screen: DRYBULK_CARGO_OPS_TELEMETRY.finalDelayReportScreen,
  },
} as const;

/**
 * DBCO-0059 (R-31, R-32, AD-98) - Print like Bay Hire: fetch the report's `:print` PDF as a Blob and open the browser print dialog.
 * The shared util owns the window, Safari and the error toasts; nothing is cached and no report value is logged or sent to telemetry.
 */
export const usePrintReport = (kind: PrintReportKind) => {
  const { t } = useTranslation();
  const { notify } = useNotification();
  const fetcher = kind === "loading" ? printFinalLoadingReport : printFinalDelayReport;
  return (operationId: string) =>
    runTransaction(
      {
        module: DRYBULK_CARGO_OPS_TELEMETRY.module,
        screen: TELEMETRY[kind].screen,
        action: TELEMETRY[kind].action,
        entityType: "cargo_operation",
        entityId: operationId,
      },
      () =>
        printRequestedTemplate({
          id: operationId,
          service: DRYBULK_CARGO_OPS_BFF_SERVICE_SEGMENT,
          requestTemplateDocument: fetcher,
          notify,
          t,
        }),
    );
};
